/* Add to cart on product cards (snippets/ov-card-atc.liquid, 4 Nov 2026): adds the chosen size without leaving the
   page, then fires the theme's cart:update so the cart count, the top bar and the free gift follow. */
(function () {
  if (window.__ovca) return;
  window.__ovca = 1;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var json = { 'Content-Type': 'application/json', Accept: 'application/json' };
  /* 5 Nov 2026: picking a size changes the card's price (and price per 100g) to that size */
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || !sel.matches || !sel.matches('[data-ovca-size]')) return;
    var o = sel.options[sel.selectedIndex];
    if (!o || !o.dataset.price) return;
    var card = sel.closest('form[data-ovca]').parentElement, n = 0;
    while (card && n < 8 && !card.querySelector('product-price, [data-ovca-price]')) { card = card.parentElement; n++; }
    if (!card) return;
    var pr = card.querySelector('product-price .price, [data-ovca-price]');
    if (pr) pr.textContent = o.dataset.price;
    var u = card.querySelector('product-price .unit-price');
    if (u) {
      u.hidden = !o.dataset.unit;
      if (o.dataset.unit) u.lastChild.textContent = ' ' + o.dataset.unit;
    }
  });
  document.addEventListener('submit', function (e) {
    var f = e.target && e.target.closest && e.target.closest('form[data-ovca]');
    if (!f) return;
    e.preventDefault();
    var b = f.querySelector('.ovca-btn');
    var idEl = f.querySelector('[name="id"]');
    if (!b || b.disabled || !idEl) return;
    var label = b.textContent;
    b.disabled = true;
    b.textContent = 'Adding…';
    fetch(root + 'cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: [{ id: Number(idEl.value), quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'ov-card-atc', data: { itemCount: cart.item_count, source: 'ov-card-atc' } } }));
        b.textContent = 'Added';
        b.classList.add('is-added');
        setTimeout(function () { b.textContent = label; b.classList.remove('is-added'); b.disabled = false; }, 1800);
      })
      .catch(function () {
        b.textContent = 'Not available';
        setTimeout(function () { b.textContent = label; b.disabled = false; }, 2200);
      });
  });
})();
